<mat-card class="dashboard-container" [class.public]="isPublic">
  @if (showHeader && !isPublic) {
    <mat-card-header class="header">
      <app-dashboard-header></app-dashboard-header>
    </mat-card-header>
  }

  @if (isPublic && (organization$ | async); as org) {
    <mat-card-header class="public-header">
      <div class="logo-container">
        @if (org.company_logo) {
          <img class="logo" [src]="org.company_logo" alt=" " />
        }
        <span>{{ org.company_name }}</span>
      </div>
    </mat-card-header>
  }

  <app-item-settings></app-item-settings>

  @if (isPublic || !loading) {
    <mat-card-content>
      @if (noItemsMessage) {
        <div class="no-items">
          <img alt="Dashboard preview" ngSrc="assets-common/images/dashboard_preview.svg" fill="" />
          <div class="info-container">
            <p>
              <mat-icon svgIcon="info"></mat-icon>
              <span class="info"> {{ 'NOTIFICATION.INFO' | translate }}</span>
            </p>
            <span class="message">{{ 'DASHBOARD.EMPTY_DASHBOARD_MESSAGE' | translate }}</span>
          </div>
        </div>
      }
      <gridster [options]="options">
        @for (item of dashboard; track item) {
          <app-dashboard-item [item]="item"></app-dashboard-item>
        }
      </gridster>
    </mat-card-content>
  } @else {
    <app-skeleton></app-skeleton>
  }

  <!-- Footer #publicFooter is needed for report PDF generation, after showing give green light for capture  -->
  @if (isPublic && !loading) {
    <mat-card-footer class="public-footer" #publicFooter>
      {{ 'REPORT.GENERATED_AT' | translate }} &nbsp;
      <app-date-display [value]="generatedDate"></app-date-display>
    </mat-card-footer>
  }
</mat-card>
